import React from "react";

const LogoSmall = () => {
  const logo = `${process.env.PUBLIC_URL}/ZenzeroLifebuoyWhite.png`;

  return (
    <img
      src={logo}
      alt="Zenzero Logo"
      style={{ width: "30px", height: "auto" }} // Adjust width and height as needed
    />
  );
};

export default LogoSmall;
